"use client";

import { useEffect } from "react";

/**
 * Registers the canvassing service worker (public/sw.js) on load.
 *
 * Production-only: a SW in dev interferes with Turbopack HMR and would cache
 * dev chunks. Registration is deferred to the ``load`` event so it never
 * competes with first paint. Failures are swallowed — the app works fine
 * without the SW; it only adds an offline read shell.
 */
export function SWRegister() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;

    const register = () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {
        /* SW registration failed — non-fatal, app still works online. */
      });
    };

    if (document.readyState === "complete") {
      register();
      return;
    }
    window.addEventListener("load", register, { once: true });
    return () => window.removeEventListener("load", register);
  }, []);

  return null;
}
